import React, { useContext, useEffect, useState } from 'react';
import { OptimizelySubitoContext } from '@sbt-web/houston-wrapper';
import { isDismissed } from './helpers';
import { VerifiedUserFakeDoor } from '.';

const TOGGLE_NAME = 'subito.web.listing.verified-badge';

const VerifiedUserFakeDoorLoader = () => {
  const [isEnabled, setIsEnabled] = useState(false);
  const { optimizely } = useContext(OptimizelySubitoContext);

  useEffect(() => {
    if (optimizely && !isDismissed()) {
      optimizely.onReady().then(() => {
        setIsEnabled(optimizely.isFeatureEnabled(TOGGLE_NAME));
      });
    }
  }, [optimizely]);

  if (isEnabled) {
    return <VerifiedUserFakeDoor />;
  }
};

export { VerifiedUserFakeDoorLoader };
